module.exports = __webpack_public_path__ + "img/3.43682655.png";